import { SvgIcon, useTheme } from "@mui/material";

interface RadioIconProps {
  disabled?: boolean;
}

export const RadioIcon = () => {
  const theme = useTheme();

  return (
    <SvgIcon
      fontSize="small"
      sx={{
        ".icon-background": {
          fill: theme.palette.backgroundColor.component,
        },
        ".icon-border": {
          stroke: theme.palette.neutral.main,
        },
      }}
    >
      <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          className="icon-background"
          fill={theme.palette.backgroundColor.component}
          height="15"
          rx="7.5"
          width="15"
          x="0.5"
          y="0.5"
        />
        <rect
          className="icon-border"
          height="15"
          rx="7.5"
          stroke={theme.palette.neutral.main}
          width="15"
          x="0.5"
          y="0.5"
        />
      </svg>
    </SvgIcon>
  );
};

export const CheckRadioIcon = ({ disabled = false }: RadioIconProps) => {
  const theme = useTheme();

  return (
    <SvgIcon
      fontSize="small"
      sx={{
        ".icon-background": {
          fill: disabled ? theme.palette.backgroundColor.component : theme.palette.secondary.main,
        },
        ".icon-border": {
          stroke: disabled ? theme.palette.neutral.main : theme.palette.secondary.contrastText,
        },
        ".icon": {
          fill: disabled ? theme.palette.neutral.main : theme.palette.secondary.contrastText,
        },
      }}
    >
      <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          className="icon-background"
          fill={theme.palette.secondary.main}
          height="15"
          rx="7.5"
          width="15"
          x="0.5"
          y="0.5"
        />
        <rect
          className="icon-border"
          height="15"
          rx="7.5"
          width="15"
          x="0.5"
          y="0.5"
        />
        <circle className="icon" cx="8" cy="8" r="5" />
      </svg>
    </SvgIcon>
  );
};
